import React from "react";
import * as Klaro from "klaro";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { checkCookie } from "../utils/helpers";
import ButtonIcon from "./common/buttonIcon";

declare global {
  interface Window {
    klaro?: any;
    klaroConfig?: any;
  }
}
function CookiePrivacy() {
  const { i18n } = useTranslation();
  const lang = i18n.language
  const klaroCookie = checkCookie('klaro')
  const config = {
    hideDeclineAll: true,
    translations: {
      it: {
        save: 'Salva le mie preferenze',
        acceptSelected: 'Salva le mie preferenze',
        consentNotice: {
          learnMore: 'Preferenze',
        },
      }
    },
    services: [
      {
        name: 'google-analytics',
        cookies: [
          ['_ga', '/', 't4event.it'],
          [/^_ga(_.*)?/, '/', 't4event.it'] // we delete the Google Analytics cookies if the user declines its use
        ],
        purposes: ['analytics'],
        default: true,
        callback: function (state: any) {
          if (!klaroCookie && state) {
            window.location.reload()
          }
        },
        onAccept: `
  dataLayer.push({'event': 'klaro-google-analytics-accepted'})
  gtag('consent', 'update', {
      'analytics_storage': 'granted',
  })
`,
        onDecline: `
    gtag('consent', 'update', {
        'analytics_storage': 'denied',
    })
`,
        onInit: `
    // initialization code here (will be executed only once per page-load)
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){dataLayer.push(arguments)}
    gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'})
`,
      }
    ],
  };

  // we assign the Klaro module to the window, so that we can access it in JS
  window.klaro = Klaro;
  window.klaroConfig = config;
  // we set up Klaro with the config
  Klaro.setup(config);

  // set language
  Klaro.defaultConfig.lang = lang
  if (!klaroCookie) {
    Klaro.show()
  }

  return (
    <>
      {klaroCookie && (<ButtonIcon
        className="manualDownload cookiesBox"
        icon="cookie"
        handleClick={() => { Klaro.show() }}
      />)}
    </>
  );
}

export default CookiePrivacy;
